export const DOCUMENT_SEND_QUALITY_RECORD = { code: 'RQ05.4', revision: 'REV.06' } as const;
